import { Text, View } from "@react-pdf/renderer";

type LabelledDataProps = { label: string; children?: React.ReactNode };

const LabelledData: React.FC<LabelledDataProps> = (props) => {
  const { label, children } = props;

  if (!children) return null;

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        rowGap: 2,
        columnGap: 5,
      }}
    >
      <Text style={{ fontWeight: "bold" }}>{label}</Text>
      <Text>{children}</Text>
    </View>
  );
};

export default LabelledData;
